import React from "react";
import PropTypes from "prop-types";
import { ConfirmAbortModal } from "@ts-digital/vrc";

const TSDialog = ({ cancelText, children, okText, onAbort, onSubmit, title, type, visible }) => {
  return (
    <ConfirmAbortModal
      title={title}
      visible={visible}
      onAbort={onAbort}
      onConfirm={onSubmit}
      confirmText={okText || "Ok"}
      abortText={cancelText || "Annulla"}
      type={type}
    >
      <div style={{ padding: "30px 0px" }}>{children}</div>
    </ConfirmAbortModal>
  );
};

TSDialog.propTypes = {
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  closable: PropTypes.bool,
  children: PropTypes.node,
  onAbort: PropTypes.func,
  onSubmit: PropTypes.func,
  okText: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  cancelText: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  visible: PropTypes.bool,
  type: PropTypes.string
};

export default TSDialog;
